import { Box, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

export const ReviewsListHeader = ({ rating, count, compact, list }: { rating: number, count: number, compact: boolean, list: boolean }) => {
    const theme = useTheme();
    return (
        <Typography variant={compact || list ? 'h3' : 'h1'} component={"div"} sx={{ textAlign: { xs: 'center', sm: 'center', md: 'initial' } }}>
            {/* <Stack direction={"row"} alignItems={"center"}> */}
            Rated {rating} out of {count}{' '}
            <Box sx={{ display: { xs: 'block', sm: 'block', md: 'inline' } }}>
                <Tooltip title="All reviews verified by independent website judge.me"><span color="success" style={{ color: theme.palette.success.main, fontSize: 'inherit', textDecoration: 'underline' }}>verified</span></Tooltip>
                {' '}reviews
            </Box>
            {/* </Stack> */}
        </Typography>
    )
}